import { BrowserRouter } from 'react-router-dom';

import { useDeviceIdentity, useProfileSync } from '@muzly/api-client';

import { useNativeSync, useScrollRestoration } from '../hooks';
import { AppToaster, DevToolLauncher } from './components';
import { OfflineBar } from './components/OfflineBar';
import { useDeepLink } from './features/link';
import { useDiagnosisRestore } from './features/onboarding/server';
import { AppRoutes } from './routes';

const AppBody = () => {
  // Native-shell integration (no-op in a plain browser). Must run inside
  // <BrowserRouter> so it can call useNavigate.
  useNativeSync();
  // Deep links the native shell forwards (custom scheme · Universal/App Links)
  // → web route. No-op in a plain browser.
  useDeepLink();
  // Device Identity: register this device with the OAuth backend (no-op when
  // VITE_API_ENDPOINT is empty). Silent — never blocks the local flows.
  useDeviceIdentity();
  // Flushes profile answers the setup/profile screens queued locally. Runs after
  // Device Identity on purpose: the first PUT can land before the session exists,
  // and that 403 is a retry, not a failure.
  useProfileSync();
  // Restores server done rounds into the local Diagnosis history the one time it's
  // empty (reinstall / wiped app data). No-op once any local Record exists.
  useDiagnosisRestore();
  // Restores the window scroll on back navigation and resets it on forward. The
  // transition library's own store cannot do the back half — see the hook.
  useScrollRestoration();

  return (
    <>
      <OfflineBar />
      {/* 상태바 뒤판. 본문이 스크롤되며 노치·시계 밑으로 지나가므로, 네이티브
          셸이 실어 주는 상단 inset만큼 페이지색으로 덮는다. 색은 styles.css 가 떠 있는
          화면의 바탕을 보고 고른다. 브라우저에서는 0 높이. */}
      <div
        aria-hidden="true"
        data-status-backplate=""
        className="pointer-events-none fixed inset-x-0 top-0 z-40"
        style={{ height: 'var(--safe-area-top, 0px)' }}
      />
      <AppRoutes />
      <DevToolLauncher />
      <AppToaster />
    </>
  );
};

export const App = () => {
  return (
    <BrowserRouter>
      <AppBody />
    </BrowserRouter>
  );
};
